/**
 * Import Dependency
 */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { injectIntl } from 'react-intl'
import * as categoryActions from '../../actions/components/category'
import * as navbarActions from '../../actions/components/navbar'
import * as stepperActions from '../../actions/components/stepper'

/**
 * Import Component
 */
import NavBarSwiper from '../../components/NavBarSwiper'

/**
 * Declare Variable
 */
const mapStateToProps = (state) => {
  return {
    user: state.user,
    merchant: state.merchant,
    categories: state.categories,
    selectedCategory: state.selectedCategory,
    selectedTag: state.selectedTag,
    isNavBarSwiperExpanded: state.isNavBarSwiperExpanded,
    isTakeaway: state.basket.isTakeaway,
  }
}
const mapDispatchToProps = (dispatch) => {
  const { selectCategory, selectSetCategory } = bindActionCreators(categoryActions, dispatch)
  const { isStickyNavbarSwiper } = bindActionCreators(navbarActions, dispatch)
  const { updateNavBarSwiperExpand } = bindActionCreators(stepperActions, dispatch)

  return {
    selectCategory,
    selectSetCategory,
    isStickyNavbarSwiper,
    updateNavBarSwiperExpand,
  }
}

/**
 * Export
 */
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(NavBarSwiper)))



// WEBPACK FOOTER //
// ./src/containers/components/NavBarSwiper.js